import { cleanUpBillingLocationsList, setBillingLocationsPagination } from "../../../reducers/billingLocationsReducer";
import { defaultPagination } from "../../../reducers/billingLocationsReducer";
import { AppDispatch } from "../../../store";

export const resetBillingLocationsList = (dispatch: AppDispatch): void => {
  dispatch(cleanUpBillingLocationsList());
  dispatch(setBillingLocationsPagination(defaultPagination));
};
